<template>
  <div>
    <ODialog ref="dialog">
      <v-card>
        <ODialogBar title="Formato do relatório" @close="dismiss" />

        <v-card-text class="pa-6">
          <v-expansion-panels v-model="copiedValue" mandatory>
            <v-expansion-panel :key="0">
              <v-expansion-panel-header>Original</v-expansion-panel-header>
              <v-expansion-panel-content>
                Cada centro de custo selecionado terá uma aba de Serviços e
                outra aba de Medição.
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel :key="1">
              <v-expansion-panel-header>Condensado</v-expansion-panel-header>
              <v-expansion-panel-content>
                Todas as linhas de medição e serviços de todos os centros de
                custo serão colocadas em uma mesma aba. Ainda será gerada outra
                aba com o resumo geral e os totais da medição.
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>

        <ODialogButtons
          class="pa-6"
          txtApply="OK"
          @cancel="dismiss"
          @apply="apply"
        />
      </v-card>
    </ODialog>

    <!-- NB: BasePicker só emite input qdo clica no clear -->
    <BasePicker
      label="Data"
      icon="mdi-file-multiple-outline"
      :orientation="orientation"
      :value="strValue"
      @input="clear"
      @open="openDialog"
    />
  </div>
</template>

<script>
import BasePicker from 'oderon-vue/cpts/pickers/BasePicker.vue'

export default {
  components: {
    BasePicker
  },
  props: {
    orientation: { type: String, default: 'horizontal' },
    value: {}
  },
  data() {
    return {
      copiedValue: 0
    }
  },
  computed: {
    strValue() {
      const horz = this.orientation == 'horizontal'
      if (this.value == 'merged') {
        return horz ? 'Formato condensado' : 'Condensado'
      } else {
        return horz ? 'Formato original' : 'Original'
      }
    }
  },
  methods: {
    clear() {
      this.$emit('input', 'original')
    },

    async openDialog() {
      this.copiedValue = this.value == 'merged' ? 1 : 0
      let res = await this.$refs.dialog.$open()
      if (res != null) {
        this.$emit('input', res)
      }
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    apply() {
      const newVal = this.copiedValue == 0 ? 'original' : 'merged'
      this.$refs.dialog.$apply(newVal)
    }
  }
}
</script>

<style></style>
